
export class PrecioExcel {
    id: string;
    nivel: number;
    indice: number;
    total: number;
    responsable: string;
    numeroAeroplanta: string;

    filaExcel: string[];   
    observacion: string;
}